import { Box, Stack, Typography } from '@mui/material';

import { ChainSvg } from 'assets/images';
import React from 'react';

interface ErrorCardProps {
    title: string;
    message?: string;
    top?: number;
}

export const ErrorCard = (props: ErrorCardProps): React.JSX.Element => {
    const { title, message, top } = props;

    return (
        <Stack sx={{ mt: top ?? 0 }}>
            <Box sx={{ textAlign: 'center' }}>
                <img
                    alt='Under development'
                    src={ChainSvg}
                    style={{
                        display: 'inline-block',
                        width: 'auto',
                        margin: '0 auto',
                        height: '250px',
                    }}
                />
            </Box>
            <Box>
                <Typography variant='h4' sx={{ textAlign: 'center', mt: 2 }}>
                    {title}
                </Typography>
                {message && (
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        {JSON.stringify(message)}
                    </Typography>
                )}
            </Box>
        </Stack>
    );
};
export default ErrorCard;
